import { Component, Host, Prop, h } from '@stencil/core';

/**
 * @slot  - Slot for adding sy-col(s), sy-row(s) and sy-cell(s).
 */
@Component({
  tag: 'sy-grid',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class Grid {
  /**
   * Defines the system used to build the grid: flexbox system or grid system.
   */
  @Prop({ reflect: true }) type: 'flex' | 'grid';

  /**
   * Defines if the grid will use all available width.
   */
  @Prop({ reflect: true }) fluid: boolean;

  /**
   * Defines the number of rows of the grid. Only considered if type is 'grid'.
   */
  @Prop() rows: number;

  /**
   * Defines the number of columns of the grid. Only considered if type is 'grid'.
   */
  @Prop() cols: number;

  /**
   * Sets the gap size between collums and rows.
   * It must be a single number value.
   */
  @Prop({ reflect: true }) gap: string;

  private getGridStyle(): any {
    let style: any = {};

    if (this.type === 'grid') {
      if (this.rows) {
        style.gridTemplateRows = `repeat(${this.rows}, 1fr)`;
      }
      if (this.cols) {
        style.gridTemplateColumns = `repeat(${this.cols}, 1fr)`;
      }
    }
    if (this.gap) {
      const gap = isNaN(Number(this.gap)) ? this.gap : `${this.gap}px`;
      style = { ...style, '--sy-grid-gap': gap };
    }

    return style;
  }

  render() {
    return (
      <Host style={this.getGridStyle()}>
        <slot></slot>
      </Host>
    );
  }
}
